<div [id]="id" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <!-- <div class="relative max-h-full rounded-lg primary-purple-light-2-background" [ngClass]="{'lg:w-1/3 2xl:w-1/4': !width, 'lg:w-1/3 2xl:w-1/6': width }"> -->
        <div class="relative max-h-full rounded-lg primary-purple-light-2-background" [class]="width ? 'lg:w-1/4 2xl:w-'+width : 'lg:w-1/3 2xl:w-1/4'">
        @if (!loading) {
            <div class="relative rounded-lg shadow dark:bg-gray-700 p-8">
                @if (icon) {
                    <div class="flex justify-center items-center">
                        <img [src]="icon" alt="icon" class="h-16 w-16" />
                    </div>
                }
                <div class="justify-center items-center">
                    <div class="flex justify-center items-center" [ngClass]="{'text-center': centerText}">
                        <h3 class="w-full text-lg font-bold dark:text-gray-400" [ngClass]="{'mt-5': icon}" [innerHTML]="literalService.get(title, true)">{{ literalService.get(title, true) }}</h3>
                        @if (!icon) {
                            <button (click)="modal.hide()" type="button" class="absolute right-2 mr-2 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                                <img [src]="images.close" class="h-6 w-6" />
                            </button>
                        }
                    </div>
                    <p class="w-full whitespace-pre-line text-base primary-purple-text dark:text-gray-400" [ngClass]="{'text-center': centerText, 'mt-1': icon, 'mt-6': !icon}" [innerHTML]="literalService.get(text, true)">{{ literalService.get(text, true) }}</p>
                </div>
                <div class="flex items-center mt-4">
                    @if (extraInfoIcon) { <img [src]="extraInfoIcon" alt="extraInfoIcon" class="h-6 w-6 mr-2" /> }
                    @if (extraInfoText) { 
                        <label class="font-normal text-base" [innerHTML]="literalService.get(extraInfoText, true)"></label>
                    }
                    @if (extraInfoCheckbox) {
                        <app-checkbox
                            [id]=""
                            [checked]="extraInfoChecked"
                            [text]="literalService.get(extraInfoCheckbox, true)"
                            (onChange)="onCheckboxChange($event)"
                        />
                    }
                </div>
                <div class="justify-center items-center mt-10" [ngClass]="{'flex': sameLineButtons}">
                    @if (!hideCancelButton) {
                        <button type="button" class="mt-2 mr-3.75 gap-4 px-4 border font-semibold h-11 w-full uppercase cursor-pointer" [ngClass]="{'primary': cancelStyle === 'primary', 'secondary': cancelStyle === 'secondary'}" (click)="onCancel()">{{ literalService.get(cancelText ?? 'cancel', true) }}</button>
                    }
                    <button type="button" class="mt-2 gap-4 px-4 border font-semibold h-11 w-full uppercase cursor-pointer bg-white text-white" [ngClass]="{'primary': confirmStyle === 'primary', 'secondary': confirmStyle === 'secondary'}"  (click)="onConfirm()">{{ literalService.get(confirmText ?? 'confirm', true) }}</button>
                </div>
            </div>
        } @else {
            <div class="p-8">
                <article class="flex w-full justify-center items-center mb-9">
                    <ng-lottie class="w-24" height="100%" width="100%" [options]="loadingAnimation" (animationCreated)="utilsService.animationCreated($event, 1)" />
                </article>
                <div class="flex flex-col items-center justify-center">
                    <p class="flex justify-center items-center text-lg font-bold mb-2">{{ literalService.get('doingAction.title', true) }}</p>
                    <p class="flex justify-center items-center text-lg font-normal">{{ literalService.get('doingAction.text', true) }}.</p>
                </div>
            </div>
        }
    </div>
</div>